import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { toggleReminder, deleteReminder } from '../../lib/services/reminders';
import { getActiveChildren, getChildById } from '../../lib/stores/children.svelte.ts';
import { formatDuration } from '../../lib/utils/time';

var root_1 = $.from_html(`· <span class="child-tag svelte-tioa8cka1gkw"> </span>`, 1);
var root_2 = $.from_html(`<span class="reminder-next svelte-tioa8cka1gkw"> </span>`);
var root = $.from_html(`<div><div class="reminder-left svelte-tioa8cka1gkw"><span class="reminder-icon svelte-tioa8cka1gkw"> </span> <div class="reminder-info svelte-tioa8cka1gkw"><span class="reminder-label svelte-tioa8cka1gkw"> <!></span> <span class="reminder-interval svelte-tioa8cka1gkw"> </span> <!></div></div> <div class="reminder-actions svelte-tioa8cka1gkw"><button class="toggle-btn svelte-tioa8cka1gkw"><div><div class="toggle-knob svelte-tioa8cka1gkw"></div></div></button> <button class="delete-btn svelte-tioa8cka1gkw" aria-label="Delete"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" class="svelte-tioa8cka1gkw"><path d="M18 6L6 18M6 6l12 12"></path></svg></button></div></div>`);

function ReminderCard($$anchor, $$props) {
	$.push($$props, true);

	const showChildName = $.derived(() => getActiveChildren().length > 1);

	const childName = $.derived(() => $.get(showChildName)
		? getChildById($$props.reminder.childId)?.name
		: undefined);

	const typeIcons = {
		pump: '🍼',
		feed: '🤱',
		hydration: '💧',
		meal: '🍽️',
		custom: '🔔'
	};

	async function handleToggle() {
		await toggleReminder($$props.reminder.id, !$$props.reminder.enabled);
		$$props.onchange();
	}

	async function handleDelete() {
		await deleteReminder($$props.reminder.id);
		$$props.onchange();
	}

	const timeUntil = $.derived(() => () => {
		const diff = $$props.reminder.nextFireAt - Date.now();

		if (diff <= 0) return 'now';

		return formatDuration(diff);
	});

	var div = root();
	let classes;
	var div_1 = $.child(div);
	var span = $.child(div_1);
	var text = $.child(span, true);

	$.reset(span);

	var div_2 = $.sibling(span, 2);
	var span_1 = $.child(div_2);
	var text_1 = $.child(span_1, true);
	var node = $.sibling(text_1);

	{
		var consequent = ($$anchor) => {
			var fragment = root_1();
			var span_2 = $.sibling($.first_child(fragment));
			var text_2 = $.child(span_2, true);

			$.reset(span_2);
			$.template_effect(() => $.set_text(text_2, $.get(childName)));
			$.append($$anchor, fragment);
		};

		$.if(node, ($$render) => {
			if ($.get(childName)) $$render(consequent);
		});
	}

	$.reset(span_1);

	var span_3 = $.sibling(span_1, 2);
	var text_3 = $.child(span_3);

	$.reset(span_3);

	var node_1 = $.sibling(span_3, 2);

	{
		var consequent_1 = ($$anchor) => {
			var span_4 = root_2();
			var text_4 = $.child(span_4);

			$.reset(span_4);
			$.template_effect(($0) => $.set_text(text_4, `Next: ${$0 ?? ''}`), [() => $.get(timeUntil)()]);
			$.append($$anchor, span_4);
		};

		$.if(node_1, ($$render) => {
			if ($$props.reminder.enabled) $$render(consequent_1);
		});
	}

	$.reset(div_2);
	$.reset(div_1);

	var div_3 = $.sibling(div_1, 2);
	var button = $.child(div_3);
	var div_4 = $.child(button);
	let classes_1;

	$.reset(button);

	var button_1 = $.sibling(button, 2);

	$.reset(div_3);
	$.reset(div);

	$.template_effect(
		($0) => {
			classes = $.set_class(div, 1, 'reminder-card svelte-tioa8cka1gkw', null, classes, { disabled: !$$props.reminder.enabled });
			$.set_text(text, typeIcons[$$props.reminder.type] || '🔔');
			$.set_text(text_1, $$props.reminder.label);
			$.set_text(text_3, `Every ${$0 ?? ''}`);
			$.set_attribute(button, 'aria-label', $$props.reminder.enabled ? 'Disable' : 'Enable');
			classes_1 = $.set_class(div_4, 1, 'toggle svelte-tioa8cka1gkw', null, classes_1, { on: $$props.reminder.enabled });
		},
		[() => formatDuration($$props.reminder.intervalMs)]
	);

	$.delegated('click', button, handleToggle);
	$.delegated('click', button_1, handleDelete);
	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	ReminderCard = $.hmr(ReminderCard);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-tioa8cka1gkw');
		ReminderCard[$.HMR].update(module.default);
	});
}

export default ReminderCard;

$.delegate(['click']);
import "bun-svelte:ReminderCard.svelte-37fvsukzebj50-style.css";